<template>
  <div>
    <info-card
      :title="personalInfoTitle"
      :data="personalInfo"
      :showEditEmployee="showEditEmployee"
      index="0"
      :get_error="get_error"
      :edit_error="edit_error"
      :edit_success="edit_success"
      :item="item"
      :activeTitle="activeTitle"
    ></info-card>
    <info-card
      :title="homeAndContactInfoTitle"
      :data="homeAndContactInfo"
      :showEditEmployee="showEditEmployee"
      index="0"
      :get_error="get_error"
      :edit_error="edit_error"
      :edit_success="edit_success"
      :item="item"
      :activeTitle="activeTitle"
    ></info-card>
    <info-card
      :title="emergencyContactTitle"
      :data="emergencyContactInfo"
      :showEditEmployee="showEditEmployee"
      index="0"
      :get_error="get_error"
      :edit_error="edit_error"
      :edit_success="edit_success"
      :item="item"
      :activeTitle="activeTitle"
    ></info-card>

    <EditEmployee
      v-if="showAddEmployee"
      @close="handleClose"
      @closeOnSuccess="closeOnSuccess"
      :showAddEmployee="showAddEmployee"
      :personalInfo="personalInfo"
      :homeAndContactInfo="homeAndContactInfo"
      :emergencyContactInfo="emergencyContactInfo"
      :sectionData="sectionData"
      :reload="reload"
      :empData="empData"
      :getEditError="getEditError"
      :getEditSuccess="getEditSuccess"
      :flushMessages="flushMessages"
      :activeTitle="activeTitle"
      :itemIndex="itemIndex"
    >
    </EditEmployee>
  </div>
</template>

<script>
import infoCard from "../infoCard.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import {
  africanCountries,
  kenyanCounties,
  kenyanTowns,
  kenyanSubCounties,
} from "@/utils/utilsData";

import moment from "moment";

export default {
  name: "GeneralInformation",
  props: ["currentEmployee"],
  components: {
    infoCard,
    EditEmployee: () =>
      import("@/components/employees/modals/editEmployee.vue"),
  },

  data() {
    return {
      personalInfoTitle: "Personal Information",
      homeAndContactInfoTitle: "Home and Contact Information",
      emergencyContactTitle: "Emergency Contact",
      empData: null,
      employeeInfo: [],
      sectionData: null,
      employees: [],
      employeeData: [],
      showAddEmployee: false,
      showEmployeeBulkUpload: false,
      updateList: false,
      showSuccess: false,
      success_msg: null,
      get_error: null,
      edit_error: null,
      edit_success: null,
      itemIndex: null,
      item: null,
      activeTitle: null,
      personalInfo: [
        {
          name: "Full Names",
          value: "",
          label: "FullNames",
        },
        {
          name: "Date of Birth",
          value: "",
          type: "date",
          label: "DateofBirth",
        },
        {
          name: "Nationality",
          value: "",
          type: "select",
          options: africanCountries.map((country) => country.Name),
          method: "showMaritalStatus",
          index: 0,
          label: "Nationality",
        },
        {
          name: "Phone",
          value: "",
          type: "tel",
          label: "PersonalPhoneNumber",
        },
        {
          name: "Email Address",
          value: "",
          type: "email",
          label: "PersonalEmail",
        },
        {
          name: "Gender",
          value: "",
          type: "select",
          options: ["Male", "Female", "Other"],
          method: "showGender",
          index: 1,
          label: "Gender",
        },
        {
          name: "Marital Status",
          value: "",
          type: "select",
          options: ["Single", "Married", "Divorced", "Widowed"],
          method: "showMaritalStatus",
          index: 2,
          label: "MaritalStatus",
        },
        {
          name: "National ID",
          value: "",
          type: "text",
          label: "NationalID",
        },
        {
          name: "NSSF",
          value: "",
          type: "text",
          label: "NSSFNumber",
        },
        {
          name: "NHIF",
          value: "",
          type: "text",
          label: "NHIFNumber",
        },
        {
          name: "KRA PIN",
          value: "",
          type: "text",
          label: "KRAPINNumber",
        },
        {
          name: "Religion",
          value: "",
          type: "select",
          options: ["Christian", "Muslim", "Hindu", "Other"],
          index: 3,
          label: "Religion",
        },
      ],
      homeAndContactInfo: [
        {
          name: "Street",
          value: "",
          label: "Street",
        },
        {
          name: "Country",
          value: "",
          type: "select",
          options: africanCountries.map((country) => country.Name),
          method: "showMaritalStatus",
          index: 1,
          label: "Country",
        },
        {
          name: "Town",
          value: "",
          type: "select",
          options: kenyanTowns,
          method: "showMaritalStatus",
          index: 1,
          label: "Town",
        },
        {
          name: "County",
          value: "",
          type: "select",
          options: kenyanCounties,
          index: 1,
          label: "County",
        },
        {
          name: "Sub County",
          value: "",
          type: "select",
          options: kenyanTowns,
          index: 1,
          label: "Sub Country",
        },
        {
          name: "Postal Address",
          value: "",
          label: "PostalAddress",
        },
        {
          name: "Postal Code",
          value: "",
          label: "PostalCode",
        },
        {
          name: "Home Email",
          value: "",
          label: "HomeEmail",
        },
        {
          name: "Phone",
          value: "",
          label: "HomePhoneNumber",
        },
      ],
      emergencyContactInfo: [
        {
          name: "Full Names",
          value: "",
          label: "EmergencyFullNames",
        },
        {
          name: "Relationship",
          value: "",
          label: "EmergencyRelationship",
        },
        {
          name: "Nationality",
          value: "",
          type: "select",
          options: africanCountries.map((country) => country.Name),
          method: "showMaritalStatus",
          index: 1,
          label: "EmergencyNationality",
        },
        {
          name: "Phone",
          value: "",
          label: "EmergencyPhone",
        },
        {
          name: "Email Address",
          value: "",
          label: "EmergencyEmail",
        },
      ],
    };
  },

  created() {
    this.getEmployeeInfo(this.getCurrentEmployeeId);
  },

  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },

  methods: {
    flushMessages() {
      this.edit_error = null;
      this.edit_success = null;
    },
    getEditError(message, itemIndex) {
      this.edit_error = message;
      this.item = itemIndex;
    },
    getEditSuccess(message, itemIndex) {
      this.edit_success = message;
      this.edit_error = message;
      this.item = itemIndex;
    },

    reload() {
      this.showAddEmployee = false;
      // this.showEditEmployee = false;
      this.getEmployeeInfo(this.getCurrentEmployeeId);
    },

    formatDate(dateString) {
      const format = "DD/MM/YYYY";
      if (dateString) {
        const dateObject = moment(dateString, format).toDate();
        return dateObject;
      } else {
        return moment(new Date()).format(format);
      }
      // return moment(dateObject).format(format);
    },

    showEditEmployee() {
      this.showAddEmployee = true;

      switch (this.getTabTitle.trim()) {
        case "Personal Information":
          this.empData = this.personalInfo;
          this.sectionData = this.personalInfo;
          this.activeTitle = "Personal Information";
          this.itemIndex = 0;
          this.sectionData.formdata = {
            FullNames: "",
            DateofBirth: "",
            Nationality: "",
            PersonalPhoneNumber: "",
            PersonalEmail: "",
            Gender: "",
            MaritalStatus: "",
            NationalId: "",
            KRAPINNumber: "",
            NHIFNumber: "",
            NSSFNumber: "",
            Religion: "",
          };
          break;

        case "Home and Contact Information":
          this.empData = this.homeAndContactInfo;
          this.sectionData = this.homeAndContactInfo;
          this.activeTitle = "Home and Contact Information";
          this.itemIndex = 1;
          this.sectionData.formdata = {
            Street: "",
            Country: "",
            Town: "",
            County: "",
            SubCounty: "",
            PostalAddress: "",
            PostalCode: "",
            HomeEmail: "",
            HomePhoneNumber: "",
          };
          //console.log(this.homeAndContactInfo, this.employeeInfo);
          break;

        case "Emergency Contact":
          this.empData = this.emergencyContactInfo;
          this.sectionData = this.emergencyContactInfo;
          this.activeTitle = "Emergency Contact";
          this.itemIndex = 2;
          this.sectionData.formdata = {
            EmergencyEmail: "",
            EmergencyFullNames: "",
            EmergencyNationality: "",
            EmergencyPhone: "",
            EmergencyRelationship: "",
          };
          break;

        default:
          break;
      }
    },

    handleClose() {
      this.showAddEmployee = false;
    },

    closeOnSuccess(message) {
      this.showAddEmployee = false;
      this.updateList = true;
      this.success_msg = message;
      this.showSuccess = true;
      setTimeout(() => {
        this.showSuccess = false;
      }, 3000);
    },

    getEmployeeInfo(id) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      axios
        .get(
          `${this.getOrganization}/employee/${id}/general/${this.$ApiVersion}/info`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data);
              this.employeeInfo = response.data.Data;
              const {
                EmergencyContact,
                HomeAndContactInformation,
                PersonalInformation,
              } = this.employeeInfo;
              console.log(PersonalInformation);
              this.personalInfo = [
                {
                  Id: PersonalInformation.Id,
                  name: "Full Name",
                  value: PersonalInformation?.Fullname,

                  label: "FullNames",
                },
                {
                  name: "Date of Birth",
                  value: this.formatDate(PersonalInformation?.DateofBirth),
                  type: "date",
                  label: "DateofBirth",
                },
                {
                  name: "Nationality",
                  value: PersonalInformation?.Nationality,
                  type: "select",
                  options: africanCountries.map((country) => country.Name),
                  method: "showMaritalStatus",
                  index: 0,
                  label: "Nationality",
                },
                {
                  name: "Phone",
                  value: PersonalInformation?.PersonalPhoneNumber,

                  type: "tel",
                  label: "PersonalPhoneNumber",
                },
                {
                  name: "Email Address",
                  value: PersonalInformation?.PersonalEmail,

                  type: "email",
                  label: "PersonalEmail",
                },
                {
                  name: "Gender",
                  value: PersonalInformation?.Gender,
                  type: "select",
                  options: ["Male", "Female", "Other"],
                  method: "showGender",
                  index: 1,
                  label: "Gender",
                },
                {
                  name: "Marital Status",
                  value: PersonalInformation?.MaritualStatus,
                  type: "select",
                  options: ["Single", "Married", "Divorced", "Widowed"],
                  method: "showMaritalStatus",
                  index: 2,
                  label: "MaritalStatus",
                },
                {
                  name: "National ID",
                  value: PersonalInformation?.NationalId,
                  type: "text",
                  label: "NationalID",
                },
                {
                  name: "NSSF",
                  value: PersonalInformation?.NSSFNumber,
                  type: "text",
                  label: "NSSFNumber",
                },
                {
                  name: "NHIF",
                  value: PersonalInformation?.NHIFNumber,
                  type: "text",
                  label: "NHIFNumber",
                },
                {
                  name: "KRA PIN Number",
                  value: PersonalInformation?.KRAPIN,
                  type: "text",
                  label: "KRAPINNumber",
                },
                {
                  name: "Religion",
                  value: PersonalInformation?.Religion,
                  type: "select",
                  options: ["Christian", "Muslim", "Hindu", "Other"],
                  index: 3,
                  label: "Religion",
                },
              ];

              this.homeAndContactInfo = [
                {
                  name: "Street",
                  value: HomeAndContactInformation?.Street,
                  label: "Street",
                },
                {
                  name: "Country",
                  value: HomeAndContactInformation?.Country,
                  type: "select",
                  options: africanCountries.map((country) => country.Name),
                  method: "showMaritalStatus",
                  index: 1,
                  label: "Country",
                },
                {
                  name: "County",
                  value: HomeAndContactInformation?.County,
                  type: "select",
                  options: kenyanCounties,
                  index: 1,
                  label: "County",
                },
                {
                  name: "Sub County",
                  value: HomeAndContactInformation?.SubCounty,
                  type: "select",
                  options: kenyanSubCounties,
                  index: 1,
                  label: "SubCounty",
                },
                {
                  name: "Town",
                  value: HomeAndContactInformation?.Town,
                  type: "select",
                  options: kenyanTowns,
                  method: "showMaritalStatus",
                  index: 1,
                  label: "Town",
                },
                {
                  name: "Postal Address",
                  value: HomeAndContactInformation?.PostalAddress,
                  label: "PostalAddress",
                },
                {
                  name: "Postal Code",
                  value: HomeAndContactInformation?.PostalCode,
                  label: "PostalCode",
                },
                {
                  name: "Home Email",
                  value: HomeAndContactInformation?.HomeEmail,

                  label: "HomeEmail",
                },
                {
                  name: "Phone",
                  value: HomeAndContactInformation?.HomePhoneNumber,

                  label: "HomePhoneNumber",
                },
              ];

              this.emergencyContactInfo = [
                {
                  name: "Full Names",
                  value: EmergencyContact?.EmergencyFullNames,

                  label: "EmergencyFullNames",
                },
                {
                  name: "Relationship",
                  value: EmergencyContact?.EmergencyRelationship,
                  label: "EmergencyRelationship",
                },
                {
                  name: "Nationality",
                  value: EmergencyContact?.EmergencyNationality,
                  type: "select",
                  options: africanCountries.map((country) => country.Name),
                  method: "showMaritalStatus",
                  index: 1,
                  label: "EmergencyNationality",
                },
                {
                  name: "Phone",
                  value: EmergencyContact?.EmergencyPhone,

                  label: "EmergencyPhone",
                },
                {
                  name: "Email Address",
                  value: EmergencyContact?.EmergencyEmail,

                  label: "EmergencyEmail",
                },
              ];
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.response.data.Message;
          }
        );
    },
  },
};
</script>
